import React, { memo } from 'react';
import { motion } from 'framer-motion';
const tomes = [{
  id: 1,
  title: 'Atención & Concentración',
  color: '#FFCBA4',
  items: ['Cuadernos de atención', 'Secuencias visuales', 'Juegos de concentración', 'Ejercicios de memoria']
}, {
  id: 2,
  title: 'Lectoescritura Inclusiva',
  color: '#FFB5C5',
  items: ['Sílabas', 'Asociación palabra-imagen', 'Comprensión lectora', 'Escritura guiada']
}, {
  id: 3,
  title: 'Lenguaje & Comunicación',
  color: '#A8E6CF',
  items: ['Pictogramas', 'Comunicación visual', 'Vocabulario', 'Expresión oral']
}, {
  id: 4,
  title: 'Emociones & Habilidades Sociales',
  color: '#D4B5E8',
  items: ['Rueda de emociones', 'Juegos sociales', 'Rutinas visuales', 'Conductas y límites']
}, {
  id: 5,
  title: 'Matemática & Lógica',
  color: '#B5D8F5',
  items: ['Números', 'Secuencias', 'Asociación lógica', 'Conteo y clasificación']
}, {
  id: 6,
  title: 'Caja de Herramientas Inclusiva',
  color: '#FFAB91',
  items: ['Guías prácticas', 'Adaptaciones áulicas', 'Estrategias inclusivas', 'Material imprimible']
}];
export function WhatYouGet() {
  return <section className="w-full bg-[#FFF8F0] py-16 sm:py-24 px-4" data-id="element-250">
      <div className="max-w-5xl mx-auto" data-id="element-251">
        <div className="text-center mb-12 sm:mb-16" data-id="element-252">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-[#3D3935] mb-4" data-id="element-253">
            ¿Qué incluye el <span className="text-[#F5A04B]" data-id="element-254">Mega Pack</span>?
          </h2>
          <p className="text-[#8B7E76] text-base sm:text-lg font-medium max-w-2xl mx-auto" data-id="element-255">
            6 tomos diseñados específicamente para acompañar el desarrollo y
            aprendizaje de cada niño, con recursos listos para imprimir y usar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-256">
          {tomes.map((tome, index) => <motion.div key={tome.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 sm:p-8 shadow-sm border border-[#EFE3D4] relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-257">
              {/* Top color accent */}
              <div className="absolute top-0 left-0 right-0 h-2" style={{
            backgroundColor: tome.color
          }} data-id="element-258" />

              <div className="flex items-center gap-4 mb-6" data-id="element-259">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center text-xl font-black text-[#3D3935] shadow-sm" style={{
              backgroundColor: tome.color
            }} data-id="element-260">
                  T{tome.id}
                </div>
                <h3 className="text-lg sm:text-xl font-black text-[#3D3935] leading-tight flex-1" data-id="element-261">
                  {tome.title}
                </h3>
              </div>

              <ul className="space-y-3" data-id="element-262">
                {tome.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-263">
                    <span className="text-[#F5A04B] mt-0.5 text-sm" data-id="element-264">✅</span>
                    <span className="text-[#8B7E76] font-semibold text-sm sm:text-base leading-snug" data-id="element-265">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}